global.__errorCount = global.__errorCount || 0;

export const incrementGlobalErrorCount = () => ++global.__errorCount;

export const getGlobalErrorCount = () => global.__errorCount;
